import { RegistrationScreen } from '@/components/utils/RegistrationScreen';
import * as P from '@/constants/paths';
import useAccountCreation from '@/hooks/registration/useAccountCreation';
import { RegistrationTrack } from '@/hooks/useRegistrationStore';
import { PasswordField } from '@design-system/DataForm/PasswordField';
import { TextField } from '@design-system/DataForm/TextField';
import { useNavigate } from 'react-router-dom';

export const RegistrationAccountCreation = () => {
  const { form, onSubmit, accountCreationPending } = useAccountCreation();
  const navigate = useNavigate();

  return (
    <RegistrationScreen
      form={form}
      title="Create Account"
      description="Please enter the information of the person who will be taking the
          test. Learn more here if you have multiple test kits in the same
          household."
      content={
        <div className="mt-8" data-testid="registrationAccountCreation-content">
          <TextField 
            name="email" 
            placeholder="Email" 
            autoComplete="off" 
            data-testid="registrationAccountCreation-emailInput"
          />
          <PasswordField
            name="password"
            placeholder="Password"
            className="mt-5"
            autoComplete="new-password"
            data-testid="registrationAccountCreation-passwordInput"
          />
          <PasswordField
            name="confirmPassword"
            placeholder="Confirm password"
            className="mt-5"
            autoComplete="off"
            data-testid="registrationAccountCreation-confirmPasswordInput"
          />
        </div>
      }
      previousPath={P.REGISTRATION_KIT_ID}
      postActionsContent={
        <p className="font-sans text-tertiary mt-6" data-testid="registrationAccountCreation-loginPrompt">
          Have an account?{' '}
          <span
            style={{
              textDecoration: 'underline',
              textDecorationColor: '#171C2ECC',
              textDecorationThickness: '1.4px',
              textUnderlineOffset: '4px',
              cursor: 'pointer',
            }}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => navigate(P.LOGIN_PATH)}
            data-testid="registrationAccountCreation-loginLink"
          >
            Login
          </span>
        </p>
      }
      primaryActionLabel="Next"
      primaryActionIsSubmit
      isLoading={accountCreationPending}
      formOnValid={onSubmit}
      checkForRegisterStore={RegistrationTrack.AccountCreation}
      data-testid="registrationAccountCreation-screen"
    />
  );
};
